import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { CanActivateChildFn } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { getDefaultActiveStep, JoinActions } from '@aaa/emember/store-join';
import { tap } from 'rxjs';

export const setActivePanelSections: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);

  return store.select(getDefaultActiveStep).pipe(
    tap((activeStep) => store.dispatch(JoinActions.setFormActiveStep({ activeStep }))),
    map(() => true),
  );
};
export default setActivePanelSections;
